<template>
  <div
    :class="[wrapperClass, { 'has-error has-danger': validator && validator.$error || errors && !wrapped }]"
  >
    <div
      v-if="wrapped"
      :id="'checkbox-wrapper-' + id"
      :class="[{ 'has-error has-danger': validator && validator.$error || errors }, checkboxWrapperClass]"
    />
    <slot name="icon"/>
    <div class="form-check">
      <label class="form-check-label">
        <input
          v-model="field"
          :value="value"
          :id="id"
          :class="[checkboxClass]"
          :disabled="disabled"
          type="checkbox"
          @change="({target}) => { !validator || validator.$touch(); $emit('change', target.checked) }"
        >
        <label :class="labelClass"
               :for="id">{{ label }}<span v-if="validator && validator.$params.required">*</span></label>
        <span class="checkmark"/>
      </label>
    </div>
    <div :id="'textarea-help-block-' + id"
         class="help-block form-text form-control-feedback">
      <template v-for="(error, index) in errors">
        <strong :key="index">{{ error }}</strong>
      </template>
      <!-- <strong
        v-if="validator && validator.$params.required && validator.$error && !validator.required"
      >you have to choose one of {{ label.toLowerCase() }}!</strong> -->
    </div>
  </div>
</template>

<script>
export default {
	name: 't-checkbox',
	props: {
		label: {
			type: String,
			default: ''
		},
		labelClass: {
			type: String,
			default: ''
		},
		checkboxClass: {
			type: String,
			default: 'form-check-input'
		},
		wrapperClass: {
			type: String,
			default: 'form-row'
		},
		checkboxWrapperClass: {
			type: String,
			default: 'col-sm-8'
		},
		value: {
			type: [Number, String, Object, Array, Boolean],
			default: false
		},
		validator: {
			type: Object,
			default: null
		},
		errors: {
			type: Array,
			default: () => null
		},
		wrapped: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		id () {
			return Math.random()
				.toString()
				.replace('0.', '')
		},
		field: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('input', value)
			}
		}
	},
	mounted () {
		if (this.wrapped) {
			let wrapper = document.getElementById(`checkbox-wrapper-${this.id}`)
			let checkbox = document.getElementById(this.id)
			let helpBlock = document.getElementById(`checkbox-help-block-${this.id}`)
			wrapper.appendChild(checkbox)
			wrapper.appendChild(helpBlock)
		}

		this.$emit('input', this.field)
	}
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/common/checkbox/index.vue